import { ModuleProps, CreateModuleProps } from "components";
import { Rights } from "./Rights";
import { Routes } from "./Routes";

export const Module: ModuleProps = CreateModuleProps({
    id: "SETTINGS_EXEMPTION_APPLICATION_SMS_RECEIVER",
    parentId: "SETTINGS_PARENT",
    applicationRights: Rights,
    title: 'Vaktbytte losforvaltning',
    text: 'Vaktbytte losforvaltning',
    icon: 'gear',
    showOnDashboardByDefault: false,
    url: "/settings/exemption-applications",
    routes: Routes
})
